import React from 'react';
import { StoreIcon, SmartphoneIcon, ZapIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
const features = [{
  icon: StoreIcon,
  title: 'Cientos de Comercios',
  description: 'Accede a descuentos en supermercados, restaurantes, cines, farmacias y mucho más.'
}, {
  icon: SmartphoneIcon,
  title: 'Tarjeta y App',
  description: 'Lleva tus beneficios siempre contigo. Muestra tu tarjeta física o digital desde la App.'
}, {
  icon: ZapIcon,
  title: 'Uso Ilimitado',
  description: 'Sin límites de uso. Ahorra en cada compra, todos los días del año.'
}, {
  icon: GiftIcon,
  title: '100% Gratis',
  description: 'Sin costos de emisión, sin mantenimiento, sin letra chica. Totalmente gratuito.'
}, {
  icon: ShieldCheckIcon,
  title: 'Seguro y Confiable',
  description: 'Tus datos están protegidos. Solo preocúpate por elegir dónde ahorrar hoy.'
}];
export function Features() {
  return <section id="beneficios" className="py-20 bg-gray-50" data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-91">
          <h2 className="text-base font-semibold text-brand-600 tracking-wide uppercase mb-2" data-id="element-92">
            Beneficios Exclusivos
          </h2>
          <p className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-93">
            Todo lo que necesitas para ahorrar
          </p>
          <p className="text-lg text-gray-600" data-id="element-94">
            ClubAhorra está diseñado para maximizar tu poder de compra sin
            complicaciones.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-95">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow border border-gray-100 group" data-id="element-96">
              <div className="w-12 h-12 bg-brand-100 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-97">
                <feature.icon className="h-6 w-6 text-brand-600" data-id="element-98" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-99">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-100">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}